import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  type = 'website',
  publishedTime,
  author 
}) => {
  useEffect(() => {
    // Set document title
    if (title) {
      document.title = `${title} | جامعة ابن النفيس للعلوم الطبية`;
    }

    // Set or update meta tags
    const setMetaTag = (name, content, isProperty = false) => {
      if (!content) return;
      
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // Basic SEO
    setMetaTag('description', description);
    if (keywords) setMetaTag('keywords', keywords);
    if (author) setMetaTag('author', author);

    // Open Graph
    setMetaTag('og:title', title ? `${title} | جامعة ابن النفيس` : 'جامعة ابن النفيس للعلوم الطبية', true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:type', type, true);
    if (url) setMetaTag('og:url', url, true);
    if (image) setMetaTag('og:image', image, true);
    if (publishedTime) setMetaTag('article:published_time', publishedTime, true);

    // Twitter
    setMetaTag('twitter:title', title ? `${title} | جامعة ابن النفيس` : 'جامعة ابن النفيس للعلوم الطبية');
    setMetaTag('twitter:description', description);
    if (image) setMetaTag('twitter:image', image);

    // Canonical URL
    if (url) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) {
        link.setAttribute('href', url);
      } else {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', url);
        document.head.appendChild(link);
      }
    }
  }, [title, description, keywords, image, url, type, publishedTime, author]);

  return null;
};

export default SEO;
